import { ComplexValue } from 'app/types-shared';

export type SelectOptionValue = ComplexValue<number>;

export interface SelectOptions {
  fetching: boolean;
  items: SelectOptionValue[];
  bookmarkedCodes?: BookmarkedCodes;
  viewModeCaseTypes?: ViewMode;
}

export type CodeSelectorState = SelectOptions;

export interface BookmarkCodeSelector {
  bookmark?: boolean;
}

export enum ViewMode {
  allCodes,
  bookmarkedCodes
}
export interface BookmarkedCodes {
  fetching: boolean;
  items: SelectOptionValue[];
}
